import React from 'react'
import { connect } from 'react-redux'
//Actions
import {
  addMetrcEmployeeKey,
  deleteMetrcEmployeeKey,
  getBiotrackAccount,
  getMetrc,
  getMetrcEmployeeKeys,
  getMetrcFacilitiesData,
  getMetrcFacilitiesDataSearch,
  getUtahIcsAccount,
  updateBiotrackAccount,
  updateMetrcAccount,
  updateMetrcEmployeeKey,
  updateUtahIcsAccount,
  deleteUtahIcsAccount,
  getNmCcdAccounts,
  updateNmCcdAccount,
  deleteNmCcdAccount,
  testNmCcdConnection,
} from '../../../actions/thirdParty'

import { fetchEmployees, searchEmployees } from '../../../actions/employee'
//Components
import Compliance from '../../../components/Compliance/Compliance'
//Wrappers
import ContainerWithTitleWrapper from '../../HOC/ContainerWithTitle'
import EditableHOCWrapper from '../../HOC/EditableHOC'
//Actions
import { getShopList } from '../../../actions/shop'
import { openErrorMessage, openSuccessMessage } from '../../../actions/message'
//
import { isValidString } from '../../../utils/string'
import moment from 'moment'
import { updateMerchantEmployeeKey } from '../../../api/complianceService'
import { serializeMetrcEmployeeConfigRequest } from '../../../utils/complianceServiceDataBuilders'
import qs from 'query-string'
import { hasAccess } from '../../../utils/api'
import { isAssignedShopInNewMexico, shouldShowNmCcdTab } from '../../../utils/nmCcdCompliance'
import { isFeatureFlagEnable } from '../../../api/unleash'
import { UnleashToggles } from '../../../types/unleashToggles'

const ComplianceEditable = EditableHOCWrapper(Compliance)
const TABS = {
  BIOTRACK_LOCATIONS: 'BIOTRACK_LOCATIONS',
  METRC_FACILITIES: 'METRC_FACILITIES',
  METRC_EMPLOYEE_KEYS: 'METRC_EMPLOYEE_KEYS',
  UTAH_ICS: 'UTAH_ICS',
  NM_CCD: 'NM_CCD',
}

const TABS_QUERY_PARAM = {
  BIOTRACK_LOCATIONS: 'biotrack-locations',
  METRC_FACILITIES: 'metrc-facilities',
  METRC_EMPLOYEE_KEYS: 'metrc-employees',
  UTAH_ICS: 'utah-ics',
  NM_CCD: 'nm-ccd',
}

class ComplianceContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: null,
      nmCcdFlagEnabled: false,
    }
  }

  loadNmCcdFlag = (assignedShop) => {
    if (!isAssignedShopInNewMexico(assignedShop)) return Promise.resolve(false)
    return isFeatureFlagEnable(UnleashToggles.NM_CCD)
      .catch(() => false)
      .then((nmCcdFlagEnabled) => {
        this.setState({ nmCcdFlagEnabled })
        if (nmCcdFlagEnabled && assignedShop.id) {
          this.props.dispatch(getNmCcdAccounts())
        }
        return nmCcdFlagEnabled
      })
  }

  onSave = () => (data, afterOnSave) => {
    let { biotrackAccount = {} } = this.props.thirdPartyReducer
    biotrackAccount.locations = data.locations
    let updatedBiotrackAccount = [{ ...biotrackAccount }]
    const isValid = this.validateBiotrackAccount(data)
    if (isValid) {
      this.props.dispatch(updateBiotrackAccount(updatedBiotrackAccount)).then((_) => {
        this.props.dispatch(getBiotrackAccount())
        afterOnSave()
      })
    }
  }

  onFacilititesSave = () => (data, afterOnSave) => {
    const { metrcAccounts } = this.props.thirdPartyReducer
    metrcAccounts[0].facilities = data.facilities
    let updatedMetrcAccount = metrcAccounts[0]
    const isValid = this.validateMetrcAccount(updatedMetrcAccount)
    if (isValid) {
      this.props.dispatch(updateMetrcAccount([{ ...updatedMetrcAccount }])).then((_) => {
        this.props.dispatch(getMetrc())
        afterOnSave()
      })
    }
  }

  onUtahIcsSave = () => (data, afterOnSave) => {
    const utahIcsAccount = (data && data.utahIcsAccount) || {}
    const isValid = this.validateUtahIcsAccount(utahIcsAccount)
    if (isValid) {
      this.props
        .dispatch(updateUtahIcsAccount(utahIcsAccount))
        .then((_) => {
          this.props.dispatch(getUtahIcsAccount())
          if (afterOnSave) {
            afterOnSave()
          }
        })
        .catch((err) => {
          // Allow local/stage environments to proceed even if the endpoint is not available yet.
          if (err?.response?.status === 404 && afterOnSave) {
            afterOnSave()
          }
        })
    }
  }

  onUtahFacilitySave = (accountPayload) => {
    const isValid = this.validateUtahIcsAccount(accountPayload)
    if (!isValid) {
      return null
    }
    return this.props
      .dispatch(updateUtahIcsAccount(accountPayload))
      .then((_) => {
        this.props.dispatch(getUtahIcsAccount())
      })
      .catch((err) => {
        if (err?.response?.status !== 404) {
          throw err
        }
        throw err
      })
  }

  onDeleteUtahAccount = (accountId) => {
    return this.props
      .dispatch(deleteUtahIcsAccount(accountId))
      .then(() => this.props.dispatch(getUtahIcsAccount()))
  }

  onNmCcdSave = (account, jwtTokenInput, operation) =>
    this.props.dispatch(updateNmCcdAccount(account, jwtTokenInput, operation))

  onDeleteNmCcdAccount = (accountId) => this.props.dispatch(deleteNmCcdAccount(accountId))

  onTestNmCcdConnection = (account, jwtTokenInput) =>
    this.props.dispatch(testNmCcdConnection(account, jwtTokenInput))

  notifyNmCcdSuccess = (message) => this.props.dispatch(openSuccessMessage(message))

  notifyNmCcdError = (message) => this.props.dispatch(openErrorMessage(message))

  validateBiotrackAccount = (data) => {
    const { shopsList } = this.props.shopReducer
    const { locations } = data
    let errorMsg = ''
    for (let i = 0; i < locations.length; i++) {
      const currentShop =
        (shopsList.values && shopsList.values.find((shop) => shop.id === locations[i].shopId)) || {}
      if (!locations[i].stateCode) {
        errorMsg = `Please select state code for ${currentShop.name || ''}`
        break
      }
    }
    if (errorMsg) {
      this.props.dispatch(openErrorMessage(errorMsg))
      return false
    }
    return true
  }

  validateMetrcAccount = (data) => {
    const { shopsList = {} } = this.props.shopReducer
    const { facilities } = data
    let errorMsg = ''

    for (let i = 0; i < facilities.length; ++i) {
      if (!facilities[i].stateCode) {
        const currentShop =
          (shopsList.values && shopsList.values.find((shop) => shop.id === facilities[i].shopId)) ||
          {}
        errorMsg = `Please select state code for ${currentShop.name || ''}`
        break
      }
    }

    if (errorMsg) {
      this.props.dispatch(openErrorMessage(errorMsg))
      return false
    }

    return true
  }

  validateUtahIcsAccount = (account) => {
    const { shopsList = {} } = this.props.shopReducer
    const { facilities = [], clientId, clientSecret, stateCode } = account || {}
    const shops = shopsList.values || []
    let errorMsg = ''

    for (let i = 0; i < facilities.length; ++i) {
      const facility = facilities[i]
      const currentShop = shops.find((shop) => shop.id === facility.shopId) || {}
      const facilityClientId = facility.clientId || clientId
      const facilityClientSecret = facility.clientSecret || clientSecret
      const facilityState = facility.stateCode || stateCode || 'UT'

      if (!facility.shopId) {
        errorMsg = 'Please select a shop for each Utah ICS facility.'
        break
      }
      if (!facilityClientId || !facilityClientSecret || !facility.facilityCode) {
        errorMsg = `Please provide clientId, clientSecret, and facility code for ${
          currentShop.name || 'the selected shop'
        }.`
        break
      }
      if (!facilityState) {
        errorMsg = `Please provide a state code for ${currentShop.name || 'the selected shop'}.`
        break
      }
      if (!facility.facilityCode) {
        errorMsg = `Please provide a facility code for ${currentShop.name || 'the selected shop'}.`
        break
      }
    }

    if (errorMsg) {
      this.props.dispatch(openErrorMessage(errorMsg))
      return false
    }

    return true
  }

  searchFacilities = (env, stateCode, apiKey) => {
    this.props.dispatch(getMetrcFacilitiesDataSearch(env, stateCode, apiKey))
  }

  onChangeActiveTab = (tab) => {
    this.setState({ activeTab: tab })
  }

  retrieveFacilities = async () => {
    await this.props.dispatch(getMetrcFacilitiesData())
  }

  onEmployeeSearch = (searchTerm) => {
    return this.props.dispatch(searchEmployees(searchTerm))
  }

  onSearchEmployeeKey = () => {
    const { searchTerm, start, limit } = this.state
    this.props.dispatch(getMetrcEmployeeKeys({ start, limit, searchTerm })).then((res) => {
      let metrcEmployeeKeys = []
      if (res && res.values && res.values.length) {
        metrcEmployeeKeys = res.values.map((element) => {
          return {
            ...element,
            editMode: false,
            lastModified: moment().valueOf(),
          }
        })
      }
      this.setState({ metrcEmployeeKeys })
    })
  }

  validateEmployeeKey = (request) => {
    if (!isValidString(request.employeeId)) {
      this.props.dispatch(openErrorMessage('Please select Employee.'))
      return false
    }

    if (!isValidString(request.userApiKey)) {
      this.props.dispatch(openErrorMessage('Please enter Metrc API Key.'))
      return false
    }

    return true
  }

  saveEmployeeKey = (request) => {
    return this.props.dispatch(addMetrcEmployeeKey(request))
  }

  onUpdateEmployeeKey = (data, afterOnSave) => {
    if (this.validateEmployeeKey(data)) {
      this.props.dispatch(updateMetrcEmployeeKey(data)).then((res) => {
        afterOnSave(res)
      })
      this.updateEmployeeMetrcKeyForMerchants(data)
    }
  }

  updateEmployeeMetrcKeyForMerchants = (data) => {
    const { userApiKey, companyId, employeeId, enabled } = data
    const request = serializeMetrcEmployeeConfigRequest(userApiKey, enabled)
    updateMerchantEmployeeKey(companyId, employeeId, request)
  }

  setEmployeeKeyForDelete = (selectedEmployeeKey) => {
    this.setState({ selectedEmployeeKey })
  }

  deleteEmployeeKey = (id) => {
    return this.props.dispatch(deleteMetrcEmployeeKey(id))
  }

  onChangeTerm = (event) => {
    this.setState({
      searchTerm: event && event.target && event.target.value ? event.target.value : '',
    })
  }

  getQueryParams = () => {
    const searchParams = window.location.search
    return qs.parse(searchParams)
  }

  componentDidMount = () => {
    const { session = {} } = this.props.authReducer
    const { assignedShop = {} } = session
    const { complianceType = '' } = assignedShop
    const queryParams = this.getQueryParams()
    const queryTab = queryParams && queryParams.tab ? queryParams.tab : ''
    switch (complianceType) {
      case 'METRC':
        if (queryTab === TABS_QUERY_PARAM.METRC_EMPLOYEE_KEYS) {
          this.setState({ activeTab: TABS.METRC_EMPLOYEE_KEYS })
        } else {
          this.setState({ activeTab: TABS.METRC_FACILITIES })
        }
        break
      case 'UTAH_ICS':
        if (queryTab === TABS_QUERY_PARAM.METRC_EMPLOYEE_KEYS) {
          this.setState({ activeTab: TABS.METRC_EMPLOYEE_KEYS })
        } else if (queryTab === TABS_QUERY_PARAM.METRC_FACILITIES) {
          this.setState({ activeTab: TABS.METRC_FACILITIES })
        } else if (queryTab === TABS_QUERY_PARAM.UTAH_ICS) {
          this.setState({ activeTab: TABS.UTAH_ICS })
        } else {
          this.setState({ activeTab: TABS.UTAH_ICS })
        }
        break
      case 'NM_CCD':
        this.setState({ activeTab: TABS.NM_CCD })
        break
      case 'BIOTRACK':
      default:
        if (queryTab === TABS_QUERY_PARAM.UTAH_ICS) {
          this.setState({ activeTab: TABS.UTAH_ICS })
        } else {
          this.setState({ activeTab: TABS.BIOTRACK_LOCATIONS })
        }
        break
    }
    this.props.dispatch(getBiotrackAccount())
    this.props.dispatch(getUtahIcsAccount())
    this.loadNmCcdFlag(assignedShop)
    this.props.dispatch(getMetrc())
    this.props.dispatch(getShopList())
    this.props.dispatch(fetchEmployees()).then(({ values }) => {
      if (values && values.length) {
        this.setState({ employees: values })
      }
    })

    if (hasAccess()) {
      this.onSearchEmployeeKey()
    }
  }

  render() {
    const {
      biotrackAccount = {},
      biotrackEmployeeKeys,
      metrcAccounts = [],
      metrcFacilities = {},
      metrcLocationTypes = [],
      utahIcsAccount = {},
      nmCcdAccounts = [],
    } = this.props.thirdPartyReducer
    const {
      employees = [],
      activeTab,
      metrcEmployeeKeys = [],
      selectedEmployeeKey,
      searchTerm = '',
      nmCcdFlagEnabled,
    } = this.state

    const { session = {} } = this.props.authReducer
    const complianceData = {
      locations: biotrackAccount && biotrackAccount.locations,
      facilities: metrcAccounts[0] && metrcAccounts[0].facilities,
      utahIcsAccount: (utahIcsAccount && Object.keys(utahIcsAccount).length && utahIcsAccount) || {
        complianceType: 'UTAH_ICS',
        stateCode: 'UT',
        environment: 'Development',
        clientId: '',
        clientSecret: '',
        facilities: [],
        companyId:
          session.companyId ||
          (session.assignedShop && session.assignedShop.companyId) ||
          undefined,
      },
    }
    const { shopsList = {} } = this.props.shopReducer
    const shopListValues = shopsList.values || []
    const utahShops =
      shopListValues.filter(
        (shopItem) => ((shopItem.address && shopItem.address.state) || '').toUpperCase() === 'UT',
      ) || []
    const showUtahTab = utahShops.length > 0
    const assignedShop = session.assignedShop || {}
    const showNmCcdTab = shouldShowNmCcdTab(assignedShop, nmCcdFlagEnabled)
    const effectiveActiveTab =
      (!showUtahTab && activeTab === TABS.UTAH_ICS) || (!showNmCcdTab && activeTab === TABS.NM_CCD)
        ? TABS.BIOTRACK_LOCATIONS
        : activeTab
    return (
      <React.Fragment>
        <ComplianceEditable
          key={
            metrcAccounts.length +
            (biotrackAccount.locations || []).length +
            ((complianceData.utahIcsAccount.facilities || []).length || 0)
          }
          metrcAccount={metrcAccounts[0]}
          shops={shopListValues}
          dataToEdit={complianceData}
          onChangeActiveTab={this.onChangeActiveTab}
          TABS={TABS}
          activeTab={effectiveActiveTab}
          onSave={this.onSave()}
          onFacilititesSave={this.onFacilititesSave()}
          onUtahIcsSave={this.onUtahIcsSave()}
          onUtahFacilitySave={this.onUtahFacilitySave}
          onDeleteUtahAccount={this.onDeleteUtahAccount}
          showUtahTab={showUtahTab}
          utahShops={utahShops}
          showNmCcdTab={showNmCcdTab}
          nmCcdAccount={
            nmCcdAccounts.find((account) => account.shopId === (session.assignedShop || {}).id) ||
            {}
          }
          nmCcdAccounts={nmCcdAccounts}
          onNmCcdSave={this.onNmCcdSave}
          onDeleteNmCcdAccount={this.onDeleteNmCcdAccount}
          onTestNmCcdConnection={this.onTestNmCcdConnection}
          notifyNmCcdSuccess={this.notifyNmCcdSuccess}
          notifyNmCcdError={this.notifyNmCcdError}
          retrieveFacilities={this.retrieveFacilities}
          biotrackEmployeeKeys={biotrackEmployeeKeys}
          searchFacilities={this.searchFacilities}
          facilitiesOptions={metrcFacilities}
          shop={session.assignedShop}
          metrcLocationTypes={metrcLocationTypes}
          dispatch={this.props.dispatch}
          employees={employees}
          metrcEmployeeKeys={metrcEmployeeKeys}
          onEmployeeSearch={this.onEmployeeSearch}
          saveEmployeeKey={this.saveEmployeeKey}
          onUpdateEmployeeKey={this.onUpdateEmployeeKey}
          validateEmployeeKey={this.validateEmployeeKey}
          searchTerm={searchTerm}
          onSearchEmployeeKey={this.onSearchEmployeeKey}
          onChangeTerm={this.onChangeTerm}
          selectedEmployeeKey={selectedEmployeeKey}
          setEmployeeKeyForDelete={this.setEmployeeKeyForDelete}
          deleteEmployeeKey={this.deleteEmployeeKey}
        />
      </React.Fragment>
    )
  }
}

const ComplianceWithTitle = ContainerWithTitleWrapper(ComplianceContainer, 'Compliance Accounts')
const ComplianceConnected = connect(
  ({ thirdPartyReducer, shopReducer, authReducer, dispatch }) => ({
    thirdPartyReducer,
    shopReducer,
    authReducer,
    dispatch,
  }),
)(ComplianceWithTitle)

export default ComplianceConnected



// WEBPACK FOOTER //
// ./src/containers/Settings/Integration/ComplianceContainer.js